import { useQuery, gql } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const NOTIFICATION_PREFERENCES_QUERY = gql`
  query GetNotificationPreferences($userUuid: UUID!) {
    notificationPreferences(userUuid: $userUuid) {
      smsPhoneNumber
      smsOptIn
    }
  }
`;

export default function useNotificationPreferences(userUuid) {
  const {
    errors,
    data = {},
    loading
  } = useQuery(NOTIFICATION_PREFERENCES_QUERY, {
    noThrow: true,
    skip: !userUuid,
    useCache: false,
    variables: {
      userUuid
    }
  });

  useError(errors);

  return {
    notificationPreferences: data?.notificationPreferences || {},
    hasUnknownError: errors?.[0]?.status >= 400,
    loading
  };
}
